module.exports = __webpack_public_path__ + "img/1105.a32b42bb.jpg";